function xor(a, b) {
  return (a || b) && !(a && b);
}

export default xor;
